export default "__VITE_ASSET__4cf48637__"